import React, { useState, useEffect } from 'react'
import { Col, Container, Row, Input, Label, Button, Form, FormFeedback, FormGroup } from "reactstrap";
import AsyncSelect from 'react-select/async';
import apiGlobal from '../global/api.global';
import * as Yup from "yup";
import { FormikProvider, useFormik } from "formik";
import '../global/GlobalCSS.css';
import Layout from '../HorizontalMenu/Menu';
import Navbar from '../HorizontalMenu/Navbar';
import VesselDetailsHeader from '../Components/VesselDetailsHeader';
import { useDispatch, useSelector } from 'react-redux';
import { VesselState, getVesselsAction, setVesselState } from "../Store/Generic/ReportingSlice";
import { Vessel } from './VoyageInformation.model';
import VoyageInformation from './VoyageInformation';
import { successToast } from '../Components/Toasts';

const CreateVoyage = () => {
    const dispatch = useDispatch();
    const { VesselState, VesselID, Vessels } = useSelector(
        (state: any) => state.Reporting
    );
    const [vesselNames, setVesselNames] = useState<Array<Vessel>>([]);
    //const [ports, setports] = useState<Array<Port>>([]);
    const [data, setData] = useState({
        voyage_number: '',
        vessel_name: VesselID,
        departure_port: '',
        departure_date_time: '',
    })

    useEffect(() => {
        dispatch(getVesselsAction('vessel_master' as string));
    }, [dispatch]);

    const record = Vessels.find((rec: any) => rec.id === VesselID);

    useEffect(() => {
        const fetchData = async () => {
            apiGlobal.get(`/vessel_general_information/`,
            ).then(res => {
                setVesselNames(res.data);
            })
                .catch(err => {
                    console.log(err);
                });
            return vesselNames;
        }; fetchData();
    }, []);

    // Form validation 
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            voyage_number: '',
            vessel_name: '',
            departure_port: '',
            departure_date_time: '',
        },
        validationSchema: Yup.object({
            voyage_number: Yup.string().matches(
                /^[A-Za-z0-9-/]{1,50}$/, "Please enter upto 50 alphabets/numbers only"
            ).required("Please enter the voyage number"),
            vessel_name: Yup.string().required("Please select the Vessel Name"),
            departure_port: Yup.string().required("Please select the Departure Port Name"),
            departure_date_time: Yup.string().required("Please enter the Date & Time of Departure"),
        }),
        onSubmit: (values) => {
        }

    });

    function handleSelect(e: any, name: any) {
        let newdata: any = { ...data }
        newdata[name] = e.id;
        setData(newdata)
    }

    const handleDate = async (e: any, name: any) => {
        let newdata: any = { ...data }
        newdata[name] = e.target.value;
        setData(newdata)
    }

    function handle(e: any) {
        const newdata: any = { ...data }
        newdata[e.target.name] = e.target.value
        setData(newdata)
    }

    const handleChanges = (event: any, validation: any) => {
        validation.handleChange(event);
        handle(event);
    }

    function submit(e: any) {
        apiGlobal.post(`/voyage_information/`, data).then(res => {
            successToast("Data saved successfully!");
        })
            .catch(err => {
                console.log(err);
            });
    }

    const customStyle = {
        control: (styles: any) => ({
            ...styles,
            borderColor: '#858484cc'
        })
    }

    const handleVesselState = (record: VesselState) => {
        dispatch(setVesselState(record))
    }

    const searchPorts = async (port: any) => {
        if (port.length >= 3) {
            try {
                const response = await apiGlobal.get(`port_master/filter_by_port_name/?port_name=${port}`);
                return response.data;
            } catch (error) {
                console.log(error);
                return [];
            }
        }
    }

    return (
        <>
            <Layout children={Navbar} />
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col>
                            <button color='primary' className='btn btn-primary mb-3' onClick={() => { handleVesselState('VOYAGE_REPORTING') }}><i className="bx bx-chevron-left me-1" /> Back</button>
                        </Col>
                        <Col>
                            <div className="pos-end">
                                <VesselDetailsHeader />
                            </div>
                        </Col>
                    </Row>
                    <div id='owner_table'>
                        <h4 className='mb-3'>Voyage Reporting</h4>
                        <FormikProvider value={validation}>
                            <Form className="needs-validation" autoComplete='off'
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    console.log(e)
                                    validation.handleSubmit();
                                    submit(e);
                                }}
                            >
                                <Row>
                                    <Col lg={6}>
                                        <Label for="voyage_number" className='required_field asteric mb-0'>Voyage number</Label>
                                        <Input
                                            type="text"
                                            className="form-control mb-3"
                                            id="voyage_number"
                                            name="voyage_number"
                                            onChange={(e: any) => handleChanges(e, validation)}
                                            value={validation.values.voyage_number || data.voyage_number}
                                            invalid={
                                                validation.touched.voyage_number && validation.errors.voyage_number ? true : false
                                            }
                                        />
                                        {validation.touched.voyage_number && validation.errors.voyage_number ? (
                                            <FormFeedback type="invalid">{validation.errors.voyage_number}</FormFeedback>
                                        ) : null}
                                    </Col>
                                    <Col lg={6}>
                                        <FormGroup className="form-floating mb-3">
                                            <div className="mb-3">
                                                <Label className='asteric'>Vessel name</Label><br></br>
                                                <h5>{record.vessel_name}</h5>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <FormGroup className="form-floating mb-3">
                                            <div className="mb-3">
                                                <Label className='asteric mb-0'>Depature port name</Label>
                                                <AsyncSelect
                                                    name='departure_port'
                                                    cacheOptions
                                                    defaultOptions
                                                    loadOptions={(e: any) => searchPorts(e)}
                                                    getOptionLabel={(e: any) => e.port_name}
                                                    getOptionValue={(e: any) => e.id}
                                                    onChange={(e: any) => handleSelect(e, 'departure_port')}
                                                    menuPortalTarget={document.body}
                                                    styles={customStyle}
                                                    noOptionsMessage={() => 'Please enter the first 3 characters of port name'}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={6}>
                                        <Label className='asteric mb-0'>Departure date & time(UTC)</Label><br />
                                        <input
                                            type="datetime-local"
                                            name='departure_date_time'
                                            //value={data.departure_date_time}
                                            onChange={(e: any) => handleDate(e, 'departure_date_time')}
                                            className='datetimepicker text-uppercase mt-0'
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <div className="d-flex flex-wrap gap-5 grp_justify_right">
                                        <Button type="submit" color="primary" className='btn_size4_5_cstm'>Save</Button>
                                        <Button type="reset" color="danger" className='btn_size4_5_cstm'>Reset</Button>
                                    </div>
                                </Row>
                            </Form>
                        </FormikProvider>
                    </div>
                </Container>
            </div>
            {VesselState === 'VOYAGE_REPORTING' && <VoyageInformation />}
        </>
    )
}

export default CreateVoyage